
const Footer = () => {

    return <>
        <footer className="bg-tertiary centers p-6">
            <img className="h-40" src="https://themonopolitan.com/assets/img/web-2.0/logo_the_monopolitan_w.svg" alt="" />
        </footer>
    </>
}
export default Footer;